import { render } from "./LaPlatforme.vue?vue&type=template&id=671be468&scoped=true"
import script from "./LaPlatforme.vue?vue&type=script&lang=js"
export * from "./LaPlatforme.vue?vue&type=script&lang=js"

import "./LaPlatforme.vue?vue&type=style&index=0&id=671be468&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671be468"]])

export default __exports__